import HttpService from "./http-service";
import AuthService from "../api/auth-service";
import ApiService from "../api/api-service";

const ApiList = [
  {
    variableName: "authService",
    classEntity: AuthService,
    route: AuthService.route,
  },
  {
    variableName: "apiService",
    classEntity: ApiService,
    route: ApiService.route,
  },
];

export interface ApiFactoryParams {
  httpService: HttpService;
}

// declaration merging with class
interface ApiFactory {
  authService: AuthService;
  apiService: ApiService;
}

class ApiFactory {
  private httpService: HttpService;

  [index: string]: any;

  constructor({ httpService }: ApiFactoryParams) {
    this.httpService = httpService;

    ApiList.forEach((api) => {
      this[api.variableName] = new api.classEntity({
        httpService,
        route: api.route,
      });
    });
  }

  saveToken(token: string) {
    this.httpService.setToken(token);
  }
}

export default ApiFactory;
